import React from "react";
import "./index.scss";
import Dialog from "@mui/material/Dialog";
import Button from "../../../SharableInputs/Button";
import InfoModalContent from "./InfoModalContent";
import SupportModalContent from "./SupportModalContent";
import DismissIcon from "../../../Assests/Images/Dismiss.svg";

const CustomModal = ({
  icon,
  header,
  isOpen,
  close,
  confirm,
  hideClose = false,
  message,
  type,
  primaryLabel,
  secondaryLabel,
  primaryIcon,
  secondaryIcon,
  isExtraButton,
  extraClick,
  extraLabel,
  closeOnOutsideClick =true,
  primaryLeft = false,
  zIndex,
}) => {
  const getContent = () => {
    switch (type) {
      case "remainder":
        return (
          <div className="d-flex flex-column gap-3 remainder-wrapper align-items-center">
            {icon && (
              <img
                src={icon}
                alt="logo"
                width={48}
                height={48}
                className="align-self-center"
              />
            )}
            <p className={`m-0 text-center header ${type}`}>{header}</p>
            <p className="m-0 message">{message}</p>
            <div className="d-flex justify-content-center align-items-center gap-3">
              <Button
                primary={true}
                type="button"
                label={primaryLabel}
                onClick={confirm}
              />
            </div>
          </div>
        );
      case "cancel":
      case "delete":
        return (
          <div className="d-flex flex-column gap-3 delete-wrapper align-items-center">
            {icon && (
              <img
                src={icon}
                alt="logo"
                width={48}
                height={48}
                className="align-self-center"
              />
            )}
            <p className="m-0 message">{message}</p>
            <div className="d-flex justify-content-between align-items-center gap-3">
              {primaryLeft ? (
                <>
                  <Button
                    primary={true}
                    type="button"
                    label={primaryLabel}
                    onClick={confirm}
                  />
                  <Button
                    label={secondaryLabel}
                    onClick={close}
                    className="fw-bold"
                    type="button"
                    secondary={true}
                    border={true}
                  />
                </>
              ) : (
                <>
                  <Button
                    label={secondaryLabel}
                    onClick={close}
                    className="fw-bold"
                    type="button"
                    secondary={true}
                    border={true}
                  />
                  <Button
                    primary={true}
                    type="button"
                    label={primaryLabel}
                    onClick={confirm}
                  />
                </>
              )}
            </div>
            {isExtraButton && (
              <div className="d-flex justify-content-between align-items-center gap-3">
                <Button
                  label={extraLabel}
                  onClick={extraClick}
                  className="fw-bold"
                  type="button"
                  secondary={true}
                  border={false}
                />
              </div>
            )}
          </div>
        );
      case "options":
        return (
          <div className="d-flex flex-column gap-3 delete-wrapper">
            {icon && (
              <img
                src={icon}
                alt="optionsIcon"
                width={20}
                height={20}
                className="align-self-center"
              />
            )}
            {header && (
              <p className={`m-0 text-center header ${type}`}>{header}</p>
            )}
            {message && <p className="m-0 message">{message}</p>}
            <div className="d-flex justify-content-between align-items-center gap-3">
              <Button
                label={secondaryLabel}
                onClick={close}
                icon={secondaryIcon || false}
                className="fw-bold"
                type="button"
                secondary={true}
                border={true}
                modalButtons={true}
              />
              <Button
                secondary={true}
                type="button"
                icon={primaryIcon || false}
                label={primaryLabel}
                onClick={confirm}
                modalButtons={true}
              />
            </div>
          </div>
        );
      case "info":
        return <InfoModalContent />;
      case "support":
        return <SupportModalContent close={close} confirm={confirm} />;
      default:
        break;
    }
  };

  return (
    <Dialog
      onClose={closeOnOutsideClick ? close : ()=>{}}
      open={isOpen}
      className={`custom-modal-container ${
        type === "info" ? "info-modal-container" : ""
      } ${type === "support" ? "support-modal-container" : ""}`}
      sx={zIndex ? { zIndex } : undefined}
    >
      {!hideClose && (
        <img
          src={DismissIcon}
          alt="logo"
          width={85}
          height={20}
          onClick={close}
          role="button"
          className="w-auto align-self-end x-icon"
        />
      )}
      {getContent()}
    </Dialog>
  );
};

export default CustomModal;
